import { all, put, takeEvery, call, select } from "redux-saga/effects";
import {
  CREW_MATERIAL_TEMPLATES_ACTIONS,
  CREW_MATERIAL_TEMPLATES_TYPES
} from "./actions";
import {
  getCrewMaterialTemplates as APIgetCrewMaterialTemplate,
  getAllCrewMaterialTemplates as APIgetAllCrewMaterialTemplate,
  createCrewMaterialTemplate as APIcreateCrewMaterialTemplate,
  updateCrewMaterialTemplate as APIupdateCrewMaterialTemplate,
  deleteCrewMaterialTemplates as APIdeleteCrewMaterialTemplate
} from "../../services/api/crewMaterialTemplates";
import {
  crewMaterialTemplateEvent,
  crewMaterialTemplateFilters,
  crewMaterialTemplateLastMaterial
} from "./selectors";
import { navigateTo } from "../navigation/saga";

export function* watchCrewMaterialTemplatesActions() {
  yield all([
    takeEvery(
      CREW_MATERIAL_TEMPLATES_TYPES.LOAD_ALL_REQUEST,
      getAllCrewMaterialTemplate
    )
  ]);
  yield all([
    takeEvery(
      CREW_MATERIAL_TEMPLATES_TYPES.LOAD_REQUEST,
      getCrewMaterialTemplate
    )
  ]);
  yield all([
    takeEvery(
      CREW_MATERIAL_TEMPLATES_TYPES.CREATE_REQUEST,
      createCrewMaterialTemplate
    )
  ]);
  yield all([
    takeEvery(
      CREW_MATERIAL_TEMPLATES_TYPES.UPDATE_REQUEST,
      updateCrewMaterialTemplate
    )
  ]);
  yield all([
    takeEvery(
      CREW_MATERIAL_TEMPLATES_TYPES.DELETE_REQUEST,
      deleteCrewMaterialTemplate
    )
  ]);
  yield all([
    takeEvery(
      CREW_MATERIAL_TEMPLATES_TYPES.CREATE_SUCCESS,
      getAllCrewMaterialTemplate
    )
  ]);
  yield all([
    takeEvery(
      CREW_MATERIAL_TEMPLATES_TYPES.UPDATE_SUCCESS,
      getAllCrewMaterialTemplate
    )
  ]);
  yield all([
    takeEvery(
      CREW_MATERIAL_TEMPLATES_TYPES.DELETE_SUCCESS,
      getAllCrewMaterialTemplate
    )
  ]);
}

function* getCrewMaterialTemplate(action) {
  let { eventId, crewMaterialId, id } = action.payload;
  try {
    const crewMaterialTemplate = yield call(
      APIgetCrewMaterialTemplate,
      eventId,
      crewMaterialId,
      id
    );
    yield put(
      CREW_MATERIAL_TEMPLATES_ACTIONS.loadSuccess(crewMaterialTemplate)
    );
  } catch (e) {
    yield put(CREW_MATERIAL_TEMPLATES_ACTIONS.loadFailure(e));
  }
}

function* getAllCrewMaterialTemplate(action) {
  let { materialId, filters, eventId } = action.payload;

  try {
    eventId = yield call(checkEventId, eventId);

    if (filters) {
      yield put(CREW_MATERIAL_TEMPLATES_ACTIONS.updateFilters(filters));
    } else {
      filters = yield select(crewMaterialTemplateFilters);
    }

    if (!materialId) {
      materialId = yield select(crewMaterialTemplateLastMaterial);
    }

    const crewMaterialTemplate = yield call(
      APIgetAllCrewMaterialTemplate,
      eventId,
      materialId,
      filters
    );
    yield put(
      CREW_MATERIAL_TEMPLATES_ACTIONS.loadAllSuccess(crewMaterialTemplate)
    );
  } catch (e) {
    yield put(CREW_MATERIAL_TEMPLATES_ACTIONS.loadAllFailure(e));
  }
}

function* createCrewMaterialTemplate(action) {
  let { materialId, values, eventId } = action.payload;

  try {
    eventId = yield call(checkEventId, eventId);
    const crewMaterialTemplate = yield call(
      APIcreateCrewMaterialTemplate,
      eventId,
      materialId,
      values
    );
    yield put(
      CREW_MATERIAL_TEMPLATES_ACTIONS.createSuccess(crewMaterialTemplate)
    );
  } catch (e) {
    yield put(CREW_MATERIAL_TEMPLATES_ACTIONS.createFailure(e));
  }
}

function* updateCrewMaterialTemplate(action) {
  let {
    eventId,
    crewMemberMaterialId,
    crewMemberMaterialTemplateId,
    values
  } = action.payload;

  try {
    eventId = yield call(checkEventId, eventId);
    const crewMaterialTemplate = yield call(
      APIupdateCrewMaterialTemplate,
      eventId,
      crewMemberMaterialId,
      crewMemberMaterialTemplateId,
      values
    );
    yield call(
      navigateTo,
      `/admin/events/${eventId}/crew-materials/${crewMemberMaterialId}`
    );
    yield put(
      CREW_MATERIAL_TEMPLATES_ACTIONS.updateSuccess(crewMaterialTemplate)
    );
  } catch (e) {
    yield put(CREW_MATERIAL_TEMPLATES_ACTIONS.updateFailure(e));
  }
}

function* deleteCrewMaterialTemplate(action) {
  const { eventId, materialId, id } = action.payload;
  try {
    const crewMaterialTemplate = yield call(
      APIdeleteCrewMaterialTemplate,
      eventId,
      materialId,
      id
    );
    yield put(
      CREW_MATERIAL_TEMPLATES_ACTIONS.deleteSuccess(crewMaterialTemplate)
    );
  } catch (e) {
    yield put(CREW_MATERIAL_TEMPLATES_ACTIONS.deleteFailure(e));
  }
}

function* checkEventId(eventId) {
  if (eventId) {
    yield put(CREW_MATERIAL_TEMPLATES_ACTIONS.updateEvent(eventId));
  } else {
    eventId = yield select(crewMaterialTemplateEvent);
  }

  return eventId;
}
